// extracted by mini-css-extract-plugin
export var cardLayout = "_7i-1";
export var paginationContainer = "_7i-0";